import { configureStore, type GetThunkAPI } from "@reduxjs/toolkit";
import { EventsSlice } from "./events/events-slice";
import { KioskSlice } from "./kiosk/kiosk-slice";
import { UISlice } from "./ui/ui-slice";

export type ThunkConfig = {
	state: RootState;
	dispatch: AppDispatch;
	rejectValue: any; // Type for your error messages
};
export type ThunkAPI = GetThunkAPI<ThunkConfig>;

export const Store = configureStore({
	reducer: {
		events: EventsSlice.reducer,
		kiosk: KioskSlice.reducer,
		ui: UISlice.reducer,
	},

	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware({
			serializableCheck: {
				ignoredActionPaths: [
					"payload.receivedAt",
					"payload.queuedAt",
					"payload.playedAt",
				],
			},
		}),
	devTools: process.env.NODE_ENV === "development",
});

export type AppStore = typeof Store;
export type RootState = ReturnType<typeof Store.getState>;
export type AppDispatch = typeof Store.dispatch;
